module.exports = __webpack_public_path__ + "static/media/tune.39e50189.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/roi/tune.png
// module id = 3312
// module chunks = 0